<style>
.head{width:100vw;height: 12vw;background-color: #fff;
padding: 0;position: relative;}
.head img.logo{height:8vw;top:2vw;display: block;left: 12vw;position: absolute;}
.head img.menu{height:8vw;top:2vw;display: block;left: 3vw;position: absolute;}
.head span.head-addr{display: block;position: absolute;left:30vw;
height: 8vw;line-height: 8vw;top:2vw;background-color: rgb(252, 213, 53);
padding: 0 2vw;border-radius: 8vw;font-size: 3vw;
font-family: Arial,sans-serif!important;}
.head_lang{height:8vw;float: right;
top: 2vw;padding: 0 2vw;border-radius: 1vw;
right: 3vw;position: absolute;}
.head_lang img.earth{display: block;float: right;width:6vw;
margin-right: 3vw;margin-top:1vw;}
.head_lang img.lightDark{display: block;float: right;width:6vw;margin-top:1vw;
border-radius: 6vw;height: 6vw; margin-right: 3vw;}
.head_lang img.bsc-usd{display: block;float: right;width:6vw;margin-top:1vw;
border-radius: 6vw;height: 6vw; }

.head_lang span{display: block;float: right; height:5vw;width:1px;
border-right:#8f8f8f solid 1px;margin-top: 1.5vw;margin-right: 3vw;}

.lang-bg{width:100vw;position: fixed;top:0;background-color: #fff;
height: 100vh;z-index: 9999999;padding: 0;overflow: hidden;}
.lang-head{width:100vw;height: 15vw;border-bottom: #eee solid 1px;}
.lang-head span{display: block;float: left;line-height: 15vw;
height: 15vw;margin-left: 5vw;font-size: 4.5vw;color: #333;
border-bottom: #C99400 solid 2px;box-sizing: border-box;}
.lang-head img{display: block;float: right;width:6vw;margin-top: 4.5vw;
margin-right: 5vw;}
.lang-bg span.lang-select{width:90vw;height: 15vw;line-height: 15vw;text-align: left;
margin: 0 auto;display: block;font-size: 4.5vw;color: #333;padding: 0;overflow: hidden;}
.lang-bg ul{width:90vw;margin: 0 auto;list-style: none;padding: 0;overflow: hidden;}
.lang-bg ul li{width:100%;height: 15vw;}
.lang-bg ul li span{font-size: 4.5vw;color: #717477;line-height: 15vw;display: block;
float: left;width:70vw;}
.lang-bg ul li img{width:6vw;height: 6vw;display: block;float: right;
margin-top: 4.5vw;}
.lang-bg ul li span.lang-on{color: #C99400;}

.draw-enter-active, .draw-leave-active {
     transition: 0.3s;
   /* transform: scale(1,1); */
     right:0;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
    /* transform: scale(1,0); */
 transform-origin: var(--popper-transform-origin);
right:-100vw;
}
.head_chain{width:30vw;position: absolute;top:0;background-color: #fff;
top:10vw;right:3vw;border-radius: 1vw;
-webkit-box-shadow:0px 0px 15px #cbcbcb; box-shadow:0px 0px 15px #cbcbcb;}
.head_chain ul{list-style: none;margin: 0;padding: 0;overflow: hidden;
padding: 1vw 0;}
.head_chain ul li{width:25vw;margin: 0 auto;height: 12vw;border-bottom: #b3b3b3 solid 1px;
color: #8f8f8f;}
.head_chain ul li:last-child{border-bottom: 0;}
.head_chain ul li img{display: block;float: left;width:8vw;height: 8vw;
border-radius: 8vw;margin-top: 2vw;border:#eee solid 1px;}
.head_chain ul li span{display: block;line-height: 12vw;font-size: 5vw;float: right;}
.head_chain ul li.on span{color: rgb(252, 213, 53);font-weight: bold;}
.left_menu{width:25vw;background: rgba(255, 255, 255, .9);position:fixed;top:15vw;left:3vw;
border-radius:3vw;padding:3vw 0;box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);z-index:99999;
display: flex;flex-direction: column;justify-content: flex-start;align-items: center;}
.leftmenu_div{width:90%;display: flex;justify-content: space-between;align-items: center;
padding: 3vw 0;;}
.leftmenu_div img{width:6vw;}
.leftmenu_div span{font-size:4vw;}
</style>
<template>
  <div class="heads">
	<div class="left_menu" v-if="menu_show">
		<div @click="tab_changes(item.url,item.id)" class="leftmenu_div" v-for="item in menu_list">
			<img :src="item.img1">
			<span>{{item.name}}</span>
		</div>
	</div>
    <div class="head">
	  <img class="menu" src="../../../static/images/menu.png" @click="do_menu_show">
      <img class="logo" src="../../../static/images/bsc_logo.png">
      <span class="head-addr" @click="to_connects" v-if="!connected">{{$t('home.index22')}}</span>
      <span class="head-addr" v-else>{{address}}</span>
      <div class="head_lang">
       <img class="bsc-usd" v-if="usd==1" @click="open_usd"  src="../../../static/images/usdt.png">
       <img class="bsc-usd" v-if="usd==2" @click="open_usd"  src="../../../static/images/usdc.png">
       <span></span>
       <img class="lightDark" v-if="chain==56" @click="open_chain"  src="../../../static/images/bsc.png">
       <img class="lightDark" v-else-if="chain==1" @click="open_chain"  src="../../../static/images/eth.png">
        <span></span>
        <img  @click="open_lang" class="earth" src="../../../static/images/earth.svg">
      </div>
      <transition name="draw">
      <div class="head_chain" v-if="chain_show">
        <ul>
          <li @click="switchToEthereum(item.id)" v-for="item in chain_list" :class="chain==item.id?'on':''">
            <img :src="item.img">
            <span>{{item.name}}</span>
          </li>
        </ul>
      </div>
      </transition>
      <transition name="draw">
      <div class="head_chain" v-if="usd_show">
        <ul>
          <li @click="switchUsd(item.id)" v-for="item in usd_list" :class="usd==item.id?'on':''">
            <img :src="item.img">
            <span>{{item.name}}</span>
          </li>
        </ul>
      </div>
      </transition>
    </div>
    <transition name="draw">
      <div class="lang-bg" v-if="lang_show">
         <div class="lang-head">
            <span>{{$t('home.index23')}}</span>
            <img @click="close_lang" src="../../../static/images/closed.svg">
         </div>
         <span class="lang-select">{{$t('home.index24')}}</span>
         <ul>
           <li @click="select_lang(item.code,item.id)" v-for="item in list">
             <span :class="item.on?'lang-on':''">{{item.name}}</span>
             <img v-if="item.on" src="../../../static/images/select.svg">
          </li>
         </ul>
      </div>
    </transition>

 </div>
</template>
<script>

export default {
  data () {
    return {
      lang_show: false,
      chain_show: false,
      usd_show: false,
      chainId: '',
      usd: 2,
     menu_show:false,
      cfg: '',
      chain_list: [{id: 56, name: 'BSC', 'img': '../../../static/images/bsc.png', on: true},
        {id: 1, name: 'ERC20', 'img': '../../../static/images/eth.png', on: false}],
      usd_list: [{id: 1, name: 'USDT', 'img': '../../../static/images/usdt.png', on: false},
        {id: 2, name: 'USDC', 'img': '../../../static/images/usdc.png', on: true}],
      list: [{id: 1, code: 'de', name: 'Deutsch', on: false},
        {id: 2, code: 'en', name: 'English', on: true},
        {id: 3, code: 'fr', name: 'Français', on: false},
        {id: 4, code: 'kr', name: '한국어', on: false},
        {id: 5, code: 'ar', name: 'بالعربية', on: false},
        {id: 6, code: 'cn', name: '简体中文', on: false},
        {id: 7, code: 'sp', name: 'Español', on: false}
        ],
	  menu_list: [{id: 1, img1: '../static/images/menu/menu11.svg', img2: '../static/images/menu/menu12.svg', name: this.$t('home.index25'), url: '/index'},
						       {id: 2, img1: '../static/images/menu/menu21.svg', img2: '../static/images/menu/menu22.svg', name: this.$t('home.index26'), url: '/mining'},
		{id: 3, img1: '../static/images/menu/menu31.svg', img2: '../static/images/menu/menu32.svg', name: this.$t('home.index27'), url: '/pledge'},
						       // {id: 4, img1: '../static/images/menu/menu41.svg', img2: '../static/images/menu/menu42.svg', name: 'Calculate', url: '/calculate'},
						       {id: 4, img1: '../static/images/menu/menu51.svg', img2: '../static/images/menu/menu52.svg', name: this.$t('home.index28'), url: '/my'}],
      ethereum: {
        chainId: '0x1',
        chainName: 'Ethereum Mainnet',
        nativeCurrency: {
          name: 'ETH',
          symbol: 'ETH',
          decimals: 18
        },
        rpcUrls: ['https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161'],
        blockExplorerUrls: ['https://etherscan.io']
      },
      bsc: {
        chainId: '0x38',
        chainName: 'Binance Smart Chain',
        nativeCurrency: {
          name: 'BNB',
          symbol: 'BNB',
          decimals: 18
        },
        rpcUrls: ['https://bsc-dataseed.binance.org/'],
        blockExplorerUrls: ['https://bscscan.com/']
      }
    }
  },
  watch: {
    address(val) {
         this.$forceUpdate()
    }
  },
  mounted() {
 const s=   this.$on('address' );
      const chainId = localStorage.getItem('chainId');
     if(!chainId || chainId == 'undefined'){
    //  console.log(chainId)
   //    this.switchToEthereum(56)
    //  if(!this.chain || !this.chain=='undefined'){
     ////    this.chain = 56
     ///   this.switchToEthereum(56)
     //   this.switchUsd(2)
     // }

     } else {
      //  this.switchToEthereum(chainId)
      //   this.switchUsd(this.usd)
    }
  },
  watch: {
    address(val) {
      console.log(val)
    }
  },
  props: ['address', 'connected', 'chain','now'],
  methods: {
	do_menu_show(){
		this.menu_show = !this.menu_show
	},
    open_lang () {
      this.lang_show = true
    },
    close_lang () {
      this.lang_show = false
    },
    open_chain () {
      this.chain_show = !this.chain_show
    },
    open_usd () {
      this.usd_show = !this.usd_show
    },
	tab_changes (url,id) {
	  if (id == this.now) {
	    return
	  }
	  this.$router.push(url)
	},
    switchUsd(id){
      const _this = this
      _this.usd_show = false
      _this.usd = id
      _this.$emit('usd_changed', id)
      if (id == 1) {
        _this.usd_list[0].on = true
        _this.usd_list[1].on = false
      } else {
        _this.usd_list[1].on = true
        _this.usd_list[0].on = false
      }
    },
    async switchToEthereum (id) {
      const _this = this
      if (id == 1 && this.chain == id) {
      //  this.$toast.center('it is Ethereum now')
        return
      } else if (id == 1 && this.chain != id) {
        _this.chainId = '0x1'
        _this.cfg = _this.ethereum
      } else if (id == 56 && this.chain == id) {
      //  this.$toast.center('it is BSC now')
        return
      } else if (id == 56 && this.chain != id) {
        _this.chainId = '0x38'
        _this.cfg = _this.bsc
      }
      try {
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [
            {
              chainId: _this.chainId
            }
          ]
        })
		 
        _this.$emit('chain_changed', id)
      //  _this.$emit('usd_changed', _this.usd)
        _this.chain_show = false
        if (id == 1) {
          _this.chain_list[0].on = true
          _this.chain_list[1].on = false
        } else {
          _this.chain_list[1].on = true
          _this.chain_list[0].on = false
        }
         localStorage.setItem('chainId', id);
      } catch (error) {
        console.log(error)
        if (error.code === 4902) {
          try {
          // 添加
            await window.ethereum.request({
              method: 'wallet_addEthereumChain',
              params: [_this.cfg]
            })
          } catch (addError) {
            console.error(addError)
          }
        } else {
          this.$toast.center(error.message)
        }
      }
    },
    select_lang (lang, id) {
      this.$i18n.locale = lang
      this.$emit('new_lang', lang)
      this.lang_show = false
      this.langed = name
      const self = this
      const newlist = []
      this.list.forEach(function (obj, index) {
        newlist[index] = obj
        if (obj.id == id) {
          newlist[index].on = true
        } else {
          newlist[index].on = false
        }
      })
      this.list = newlist
    },
    to_connects () {
      // this.connected = true
      this.$emit('change', true)
    }
  },
  watch: {

  }
}
</script>
